webClient.controller('AirPaymentBe2Bill', ['$scope', '$window', '$timeout', '$i18next', 'tseApiClient', 'tseUtil', 'tseAirResultsHelper', 'trackingService', 'gtmProduct', 'omnitureService',
    function ($scope, $window, $timeout, $i18next, tseApiClient, tseUtil, airHelper, trackingService, gtmProduct, omnitureService) {
    $scope.getText = function (key) { return window.culture.texts[key]; };
    $scope.apiClient = tseApiClient.createClient($window.site.apiUrl, $window.site.apiUrlSSL);
    var searchUrl = $window.site.currentAirRequest.searchUrl + "?" + tseUtil.Location.getQueryString();

    var bkgData = tseUtil.Session.get('bkgData_' + $window.site.currentAirRequest.requestId);
    $scope.bkgData = bkgData;
    window.$scope = $scope;
    window.displayBrandedFaresSummary = true;
    $scope.enableUpSellProducts = $window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true';
    $scope.accommodation = null;
    $scope.siteType = window.site.type;
  
        $.getScript("/Global/js/widgets/mrfly-widget-loader.js").done(function () {

        });
  
    var hfields = null;
    if ($window.isAirbus) $scope.isAirbus = $window.isAirbus;

    //Tracking
    try {
        //GTM
        if (trackingService.isActivated()) {
            trackingService.initDataLayer('checkout');
            trackingService.loadSessionData('step', 3);
            trackingService.setOption($scope.bkgData.bookingResponse.paymentMethod.paymentMethodName);
            trackingService.parseScope($scope);
            trackingService.pushDataLayer('step', 4);
        }

        //omniture
        if (omnitureService.isActivated()) {
            omnitureService.sendEvent(omnitureService.PURCHASE_4_VOL, omnitureService.FLIGHT_TUNNEL, null);
        }
    }
    catch (ex) {
        console.log(ex.message);
        $window.trackingError = ex.message;
    }
    $scope.LoadVueJsWidgets = function () {
        if ($scope.bkgData.accommodations && $scope.bkgData.accommodations.any()) {

            
                $.getScript("/Global/js/widgets/mrfly-widget-accommodation-info.js").done(function () {
                    //Get from session
                    var accommodationKey = 'accommodation_' + $scope.bkgData.accommodations[0].accommodationId;
                    var accommodationJson = $window.sessionStorage.getItem(accommodationKey);
                    var accommodation = JSON.parse(accommodationJson);

                    mrflyWidgets['mrfly-widget-accommodation-info'].locale = $window.lng.substring(0, 2);
                    mrflyWidgets['mrfly-widget-accommodation-info'].accommodation = accommodation;
                    mrflyWidgets['mrfly-widget-accommodation-info'].siteType = window.site.type;
                    if ($scope.bkgData.agencyMarginHotel) {
                        mrflyWidgets['mrfly-widget-accommodation-info'].agencyMarginHotel = $scope.bkgData.agencyMarginHotel.value;
                    }
                })
                .fail(function( jqxhr, settings, exception ) {
                    console.log(exception);
                });


                $.getScript("/Global/js/widgets/mrfly-widget-basket-total-price.js").done(function () {
                    mrflyWidgets['mrfly-widget-basket-total-price'].price = $scope.bkgData.totalBasketPrice();
                })
                .fail(function( jqxhr, settings, exception ) {
                    console.log(exception);
                });
           
        }
    };

    if (bkgData) {
        bkgData.totalBasketPrice = function (purchaseResponse) {
            
            if ($scope.bkgData.accommodations && $scope.bkgData.accommodations.any()) {
                return bkgData.prixTotal.value + bkgData.accommodations[0].totalPriceForcedPrice;
            } else {
                return bkgData.prixTotal.value;
            }
        };

        var keyGenerated = "";
        keyGenerated = bkgData.request.requestId + "_" + bkgData.purchaseRequest.index + "_" + bkgData.purchaseRequest.group + "_" + bkgData.purchaseRequest.proposal;
        bkgData.bookingRequest = tseUtil.Session.get("bookingRequest_" + keyGenerated);
        if (bkgData.purchaseResponse.productIsTrain) $scope.hideInsurance = bkgData.purchaseResponse.productIsTrain;
       else $window.hideInsurance ? $scope.hideInsurance = true : $scope.hideInsurance = false;
        if (bkgData.bookingRequest != null && bkgData.bookingRequest.requestId == bkgData.request.requestId) {
            var _insuranceSelected = tseUtil.Session.get("insurancesSelected_" + keyGenerated);
            bkgData.insurancesSelected = _insuranceSelected;

            $scope.bankCardsKey = bkgData.bookingRequest.paymentMethod.bankCard.bankCards.groupByKey("bankCardReference");

            $scope.webProcessed = true;
            if ($window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true') {
                $scope.LoadVueJsWidgets();
            }
            
            $scope.updateBookingSummary = function () {
                $scope.$broadcast("onBookingSummaryUpdate");
            };

            $scope.$on("onBookingSummaryUpdateCompleted", function (event, args) {
                
                if (bkgData.accommodations && bkgData.accommodations.any() && $scope.isAirbus) {
                    $scope.prixTotalWithoutMargin = { value : bkgData.prixTotalWithoutMargin.value + bkgData.accommodations[0].totalPriceForcedPrice };
                }
                else {
                    $scope.prixTotalWithoutMargin = bkgData.prixTotalWithoutMargin;
                }
            });
            $scope.updateBookingSummary();

            window.tokenizeHandler = function () {
                var cardName = $("#i-sec-owner").val();
                if (cardName == null || cardName == undefined || cardName == "") {
                    $window.XLConfirm({ vTitle: $i18next.t("simplepayment.checkdata"), vTextYes: "OK", vHideNo: true });
                    return;
                }

                hfields.createToken(function (result) {
                    //be2bill result
                    console.log(result);
                    if (result.execCode == '0000') {
                        // Add token to form request
                        // Also add cardtype: unknown / visa / mastercard / american_express / maestro / bancontact
                        $scope.goTo(result.hfToken, result.cardType,result.selectedBrand);
                    }
                    else {
                        $window.XLConfirm({ vTitle: "Error", vTextYes: "OK", vHideNo: true });
                    }
                });
                return false;
            };


            $scope.setBankCardReference = function (key) {
                $scope._cardReference = key;
            };

            $scope.goTo = function (item, cardType, selectedBrand) {

                var selectedBrand = (typeof selectedBrand !== 'undefined') ? selectedBrand : "";

                //$window.sendAnalytics('/Flightsearch/Payment/CBwait', 'Payment CB Wait');

                //Tracking
                try {
                    //GTM
                    if (trackingService.isActivated()) {
                        trackingService.pushPageData('/Flightsearch/Payment/CBwait', 'Payment CB Wait', lng, false);
                    }
                }
                catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }

                //$window.sendXiti("tunnel_resavol::attente_paiement_resavol", 3);

                $window.site.pushNoBackOnHistory();
                var cardName = $("#i-sec-owner").val();

                window.mrflyWidgets['airbooking-process-loader'].$store.commit("showLoader");


                var ReturnParameters = [];
                ReturnParameters[0] = { "Key": "HfToken", "Value": item };
                ReturnParameters.push({ "Key": "SelectedBrand", "Value": selectedBrand });
                if(window.site.partnerId == "servair"){
                    //PostTotal Before Payment and get result 

                    $window.Typescript.Servair.Services.ServairService.doPostTotal(bkgData.bookingRequest.requestId,$window.site.currentAirRequest.bookingId).then(function (result) {
                   
                        if (result.data === true) {
                            //ReturnParameters[1] = { "Key": "AliasCreated", "Value": $("#i-check-f1")[0].checked ? "1" : "0" };
                            $scope.apiClient.processPayment({
                                "requestId": bkgData.bookingRequest.requestId,
                                "purchaseId": $scope.bkgData.purchaseResponse.purchaseId,
                                "paymentId": bkgData.bookingResponse.paymentId,
                                "type": 1,
                                "returnUrl": $window.returnUrlFor3DS,
                                "paymentMethod": $scope.bkgData.bookingRequest.paymentMethod,
                                "transactionMethod": $scope.bkgData.bookingRequest.paymentMethod.transactionMethod,
                                "bankcard": {
                                    "cardholder": cardName,
                                    "reference": cardType
                                },
                                "returnParameters": ReturnParameters
                            }).success(function (data) {
                                var finishUrl = tseUtil.Url.appendValueToUrlBefore($window.site.currentAirRequest.finishUrl, "prqid", data.paymentRequestId);
                                window.location.href = finishUrl;
                            });
                        }
                        else {
                            //redirect to error page because postTotal failed
                            document.location.href = "/airpaymentresponse/" + bkgData.bookingRequest.requestId + "/" + $window.site.currentAirRequest.bookingId+"?posttotalfailed=1";
                        }
                   
                 });
                }
                else{
                    //ReturnParameters[1] = { "Key": "AliasCreated", "Value": $("#i-check-f1")[0].checked ? "1" : "0" };
                    $scope.apiClient.processPayment({
                        "requestId": bkgData.bookingRequest.requestId,
                        "purchaseId": $scope.bkgData.purchaseResponse.purchaseId,
                        "paymentId": bkgData.bookingResponse.paymentId,
                        "type": 1,
                        "returnUrl": $window.returnUrlFor3DS,
                        "paymentMethod": $scope.bkgData.bookingRequest.paymentMethod,
                        "transactionMethod": $scope.bkgData.bookingRequest.paymentMethod.transactionMethod,
                        "bankcard": {
                            "cardholder": cardName,
                            "reference": cardType
                        },
                        "returnParameters": ReturnParameters
                    }).success(function (data) {
                        var finishUrl = tseUtil.Url.appendValueToUrlBefore($window.site.currentAirRequest.finishUrl, "prqid", data.paymentRequestId);
                        window.location.href = finishUrl;
                    });
                }


            };

            angular.element(function () {

                console.log("initializing be2bill");

                var id = $scope.bkgData.bookingRequest.paymentMethod.bankCard.apiKeyId;
                var value = $scope.bkgData.bookingRequest.paymentMethod.bankCard.apiKeyValue;
                var fontFamily = "Arial, Helvetica, sans-serif";
                var fontSize = "14px";
                var style = {
                    "input": {
                        "font-size": fontSize                        
                    },
                    "::placeholder": {
                        "font-size": fontSize,
                        "font-family": fontFamily,
                        "color": "#999999"
                    },
                    ":valid": {
                        "font-family": fontFamily,
                        "font-size": fontSize
                    },
                    ":empty": {
                        "font-family": fontFamily,
                        "font-size": fontSize
                    },
                    ":focus": {
                        "font-family": fontFamily,
                        "font-size": fontSize
                    },
                    ":invalid": {
                        "font-family": fontFamily,
                        "font-size": fontSize
                    }
                };
                hfields = be2bill.hostedFields({
                    key: {
                        id: id,
                        value: value
                    },
                    fields: {
                        'brand': {
                            id: 'brand-container'
                        },
                        'card': {
                            id: 'card',
                            placeholder: $i18next.t('simplepayment.cardnumber'),
                            style: style,
                            enableAutospacing: true,
                        },
                        'expiry': {
                            id: 'expiry',
                            placeholder: $i18next.t('simplepayment.date'),
                            style: style
                        },
                        'cryptogram': {
                            id: 'cryptogram',
                            placeholder: $i18next.t('simplepayment.ccv'),
                            style: style
                        },
                    },
                    location: "fr"
                });
                hfields.load();
            });
        }
        else {
            $window.FLoading({ vAction: 'show' });
            window.location.href = searchUrl;
        }

        //Taxes details click
        $scope.$on("displayTaxesDetailsClick", function (event, args) {
            $scope.displayTaxesDetailModal = true;
            $scope.modalTaxesKey = args.key.replaceAll(":", "-");
            $scope.modalTaxesKey = $scope.modalTaxesKey.replaceAll("\\|", "-");
            $scope.modalTaxesKeyAux = $scope.modalTaxesKey + "-" + args.paxFares.paxType;
            $scope.modalTaxesPaxFares = args.paxFares;
            
            $scope.modalShowMargin = false;

            var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

            args.marketingCarriers.each(function (value, key) {

                if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                    $scope.modalShowMargin = true;
                }
            });

            $scope.$broadcast("updateTaxesDetailModalData", { key: $scope.modalTaxesKey, fares: $scope.modalTaxesPaxFares });

            //Remodal workaround
            $(document).find(".remodal").each(function (a, c) {
                var d = $(c), e = d.data("remodal-options");
                e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                    d["remodal"](e)
            });

            $timeout(function () {
                $('[data-remodal-id=' + 'taxes-detail-modal-' + $scope.modalTaxesKeyAux + ']').remodal().open();
            },
                200, false);
        });

        //Luggage details click
        $scope.$on("displayLuggageDetailsClick", function (event, args) {
            $scope.displayLuggageDetailModal = true;
            $scope.modalLuggageBagType = args.bagType;

            $scope.$broadcast("updateLuggageDetailModalData", { bagType: $scope.modalLuggageBagType });

            $scope.modalShowMargin = false;

            var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

            args.marketingCarriers.each(function (value, key) {

                if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                    $scope.modalShowMargin = true;
                }
            });

            //Remodal workaround
            $(document).find(".remodal").each(function (a, c) {
                var d = $(c), e = d.data("remodal-options");
                e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                    d["remodal"](e)
            });

            $timeout(function () {
                $('[data-remodal-id="luggage-detail-modal"]').remodal().open();
            },
                200, false);
        });


    }
    else {
        $window.FLoading({ vAction: 'show' });
        window.location.href = searchUrl;
    }
}]);